module.exports = __webpack_public_path__ + "static/media/unable_to_retrieve_image.a91b4b1c.png";